import { DAIMI_TO_INTRO, DAIMI_TO_SLUG } from '@/content/daimiTourism'
import { focus } from '@/content/reportBuilder'
import type { Report } from '@/content/reportBuilder'

export const report: Report = {
  // The twenty-second report with a designed page of its own, and the seventh focus
  // cut to arrive with both of its figures — asked for on 2026-08-28 in the same
  // words as the Utilities cut the day before (*"referans alarak ilgili sayfayı
  // birebir tıpa tıp aynısını tasarla"*) with a four-part full-page capture of the
  // live page, the cover as two overlapping 2000px crops, Figure 1 and the report
  // mockup. See `content/daimiTourism.ts` and `pages/DaimiTourism.tsx`.
  ...focus(
    DAIMI_TO_SLUG,
    'Tourism',
    'daimi-report-2026-tourism-cover',
    '190c7ccb-8fe5-4ddd-b777-a07d430bcdf1-digitopia-daimi-2026-report-tourism.pdf',
  ),
  // The sector's own paragraphs, transcribed from the reference capture and held
  // on the page that says them — so the search result and the page cannot drift
  // apart. `prerender.tsx` takes the meta description from `body[0]`.
  body: DAIMI_TO_INTRO.body,
  layout: 'tourism-focus',
  // Its own words, its cover, its file and both of its figures, so `stillToCome`
  // has nothing left to say about it. What is still open is section-by-section on
  // its page, and `daimiTourismChecks()` carries that into the manifest.
  check: undefined,
}

/** Its place in the index grid — the order the imported page listed them. */
export const order = 18
